import Vue from 'vue'
import VueRouter from 'vue-router'
import PageOne from '@/views/PageOne'
import PageNotFound from '@/views/errors/PageNotFound'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'pageOne',
    component: PageOne
  },
  {
    path: '/bikes',
    name: 'pageTwo',
    component: () => import(/* webpackChunkName: "pageTwo" */ '@/views/PageTwo.vue')
  },
  {
    path: '/info',
    name: 'pageThree',
    component: () => import(/* webpackChunkName: "pageThree" */ '@/views/PageThree.vue')
  },
  {
    path: '/checkout',
    name: 'pageFour',
    component: () => import(/* webpackChunkName: "pageFour" */ '@/views/PageFour.vue')
  },
  {
    path: '/checkout/:bookingId',
    name: 'pageFourWithId',
    component: () => import(/* webpackChunkName: "pageFour" */ '@/views/PageFour.vue')
  },
  {
    path: '/complete/:bookingId/:apiSignature',
    name: 'completePage',
    props: true,
    component: () => import(/* webpackChunkName: "completePage" */ '@/views/completePage.vue')
  },
  {
    path: '/404',
    name: 'notFound',
    component: PageNotFound
  },
  {
    path: '*',
    component: PageNotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  // Mailchimp Campaign Tag
  if (to.query.mc_cid) {
    store.commit('setCampaign', {
      campaign_type: 'CAMPAIGN_MAILCHIMP',
      campaign: to.query.mc_cid
    })
  }
  next()
})

export default router
